import React, { useRef, useState } from 'react';
import { Loader2, Check, ShieldCheck } from 'lucide-react';
import { useT } from '../i18n';

const API = process.env.REACT_APP_BACKEND_URL;

/* Self-hosted "I am not a robot" check: honeypot + timing signals → single-use server token.
   Parent sends the token as the X-Human-Token header. */
export const HumanCheck = ({ onToken, dark = false, className = '' }) => {
  const { lang } = useT();
  const isEs = lang === 'es';
  const [state, setState] = useState('idle'); // idle | busy | ok | error
  const mounted = useRef(Date.now());
  const hp = useRef(null);

  const click = async () => {
    if (state === 'ok' || state === 'busy') return;
    setState('busy');
    const elapsed = Date.now() - mounted.current;
    if (elapsed < 850) await new Promise((res) => setTimeout(res, 850 - elapsed));
    try {
      const r = await fetch(`${API}/api/security/human`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ elapsed_ms: Date.now() - mounted.current, hp: hp.current?.value || '' }),
      });
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.token) { setState('ok'); onToken(d.token); } else setState('error');
    } catch { setState('error'); }
  };

  const label = state === 'ok'
    ? (isEs ? 'Verificado' : 'Verified')
    : state === 'error'
      ? (isEs ? 'Error — reintentar' : 'Error — retry')
      : (isEs ? 'No soy un robot' : "I'm not a robot");

  return (
    <div className={className}>
      <input ref={hp} type="text" name="website_url_confirm" tabIndex={-1} autoComplete="off"
        className="absolute w-0 h-0 opacity-0 pointer-events-none" aria-hidden="true" />
      <button type="button" onClick={click} role="checkbox" aria-checked={state === 'ok'} data-testid="human-check"
        className={`inline-flex items-center gap-2.5 rounded-xl border px-4 py-2.5 text-[13px] font-semibold transition-colors ${
          state === 'ok'
            ? 'border-emerald-400 bg-emerald-50 text-emerald-700'
            : dark
              ? 'border-white/25 bg-white/5 text-neutral-300 hover:border-[#F77F11]'
              : 'border-neutral-300 bg-white text-neutral-600 hover:border-[#F77F11]'
        }`}>
        <span className={`w-5 h-5 rounded-md border flex items-center justify-center shrink-0 ${
          state === 'ok' ? 'border-emerald-500 bg-emerald-500 text-white' : dark ? 'border-white/40' : 'border-neutral-400'
        }`}>
          {state === 'busy' ? <Loader2 className="w-3.5 h-3.5 animate-spin text-[#F77F11]" /> : state === 'ok' ? <Check className="w-3.5 h-3.5" /> : null}
        </span>
        {label}
        <ShieldCheck className={`w-3.5 h-3.5 ${state === 'ok' ? 'text-emerald-500' : 'text-neutral-400'}`} />
      </button>
    </div>
  );
};
